import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

// The Teams manifest uses path-based URLs (e.g. /configure, /review/123)
// for tab content and configuration, while HashRouter expects /#/… form.
// When the SPA is served for a path-based URL (via FastAPI's catch-all),
// rewrite the URL to hash form once, before React mounts.
(function hashifyIfNeeded() {
  const path = window.location.pathname;
  if (path === "/" || window.location.hash) return;
  const rest = path + window.location.search;
  window.history.replaceState(null, "", `/#${rest}`);
})();

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing in index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
